import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import "../config";
import grayEvercomm from "../evercomm-singapore-logo.png";
import { useNavigate } from "react-router-dom";
import { colorTheme, invertDarkTheme } from "../Style/ColorTheme/colorTheme";
import commonStore from "../Store/marco/commonStore";
const color_Theme = colorTheme();
const invert_darkTheme = invertDarkTheme();

export const FooterBar = inject("store")(
  observer((props) => {
    // const { t } = useTranslation(window.location.pathname.replace("/", ""));
    const { t } = useTranslation("common");
    const { version } = commonStore;
    const { theme, isBlueOnion } = props.store.common;
    const navigate = useNavigate();

    return (
      <div
        className="text-center py-1 fixed-bottom"
        style={{
          fontSize: 14,
          color: invert_darkTheme(theme),
          fontFamily: color_Theme.fontFamily,
          background:
            theme === "dark"
              ? "linear-gradient(-60deg, rgb(16, 24, 65), rgb(32, 43, 96))"
              : "linear-gradient(-60deg, rgb(246, 246, 246), rgb(246, 246, 246))",
          borderTop:
            theme === "dark" ? "1px solid #ffffff20" : "1px solid #00000020",
          zIndex: "400",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontFamily: color_Theme.fontFamily,
          }}
        >
          {/* 左側區塊（當 isBlueOnion === "true" 顯示內容，否則空欄） */}
          <div
            className="ms-5"
            style={{ textAlign: "left", flex: 1, marginLeft: "10px" }}
          >
            {isBlueOnion === "true" && (
              <span>BlueOnion Group Holdings Ltd. 2024</span>
            )}
          </div>

          {/* 中間區塊（始終顯示 Powered by Evercomm + 版本號） */}
          <div
            style={{
              textAlign: "center",
              flex: 1,
              color:
                theme === "dark"
                  ? color_Theme.dark.footerText
                  : color_Theme.light.footerText,
            }}
          >
            Powered by
            <a
              href="https://www.evercomm.com.sg"
              target="_blank"
              rel="noopener noreferrer"
            >
              {theme === "dark" ? (
                <img
                  style={{
                    width: "auto",
                    height: "15px",
                    marginLeft: "5px",
                    marginTop: "-7px",
                    marginRight: "5px",
                  }}
                  src="/evercomm-singapore-white.png"
                  alt="Evercomm"
                />
              ) : isBlueOnion === "true" ? (
                <img
                  style={{
                    width: "auto",
                    height: "15px",
                    marginLeft: "5px",
                    marginTop: "-7px",
                    marginRight: "5px",
                  }}
                  src={grayEvercomm}
                  alt="Evercomm"
                />
              ) : (
                <img
                  style={{
                    width: "auto",
                    height: "15px",
                    marginLeft: "5px",
                    marginTop: "-7px",
                    marginRight: "5px",
                  }}
                  src="/evercomm-singapore.png"
                  alt="Evercomm"
                />
              )}
            </a>
            {version}
          </div>

          {/* 右側區塊（根據 isBlueOnion 顯示不同內容） */}
          <div
            className="me-5"
            style={{ flex: 1, textAlign: "right", marginRight: "10px" }}
          >
            {isBlueOnion === "true" ? (
              <>
                <span
                  onClick={() => navigate("/disclaimer")}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  Disclaimer
                </span>
                <span style={{ margin: "0 10px", fontSize: "14px" }}>|</span>
                <span
                  onClick={() => navigate("/terms-conditions")}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  Terms and Conditions
                </span>
              </>
            ) : (
              <span
                style={{
                  fontSize: "14px",
                  color:
                    theme === "dark"
                      ? color_Theme.dark.footerText
                      : color_Theme.light.footerText,
                }}
              >
                {/* 最佳顯示解析度：1280px 以上 */}
                {t("Recommended Display Resolution")}: 1280px * 960px
              </span>
            )}
          </div>
        </div>
      </div>
    );
  })
);

export default FooterBar;
